import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// Title component
export const Title = styled(Typography)({
  fontSize: "16px"
});

// Group Label component
export const GroupLabel = styled(Typography)(({ theme }) => ({
  margin: "0",
  fontSize: "16px",
  fontWeight: "500",
  lineHeight: "24px",
  color: "var(--Color-Text-Primary-On-Light, #1F1F1F)"
}));

// Flex Container component
export const FlexContainer = styled(Box)({
  marginTop: "20px",
  marginBottom: "0",
  borderBottom: "solid 1px rgba(230, 230, 230, 0.5)"
});

// Flex Container Main component
export const FlexContainerMain = styled(Box)({
  marginTop: "20px",
  marginBottom: "0"
});

// Divider component
export const Divider = styled(Box)({
  borderBottom: "solid 1px rgba(230, 230, 230, 0.5)"
});

// Controls Wrapper component
export const ControlsWrapper = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  margin: "20px 0 0"
});

// Relative positioned component
export const RelativeBox = styled(Box)({
  position: "relative"
});

// Tablet responsive component
export const TabletBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.only("xs")]: {
    marginBottom: "20px"
  }
}));

// Container component
export const PositionedContainer = styled(Box)(({ theme }) => ({
  top: "15px",
  right: "-100px",
  [theme.breakpoints.only("xs")]: {
    top: "70px",
    right: "12px"
  }
}));

// Margin Bottom component for responsive design
export const MarginBottomBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.only("xs")]: {
    marginBottom: "45px"
  }
}));

// Button Wrapper component
export const ButtonWrapper = styled(Box)({
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  margin: "40px 0"
});

// Text component
export const Text = styled(Typography)({
  fontSize: 14,
  padding: 15
});

// Remove Button component
export const RemoveButton = styled(Box)({
  float: "right",
  position: "inherit",
  marginRight: "20px",
  padding: "5px 10px",
  borderRadius: "20px",
  "& span": {
    textDecoration: "none"
  }
});

// Add Button component
export const AddButton = styled(Box)({
  marginRight: "20px",
  padding: "5px 10px",
  borderRadius: "20px",
  "& span": {
    textDecoration: "none"
  }
});
